import { RefObject, useEffect, useState } from 'react';

export function useInViewPort<T extends HTMLElement>(
  nodeRef: RefObject<T>,
  options?: IntersectionObserverInit,
) {
  const [inViewPort, setInViewPort] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setInViewPort(entry.isIntersecting);
    }, options);
    const currentRef = nodeRef.current;
    if (nodeRef.current) {
      observer.observe(currentRef as any);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [nodeRef, options]);
  return inViewPort;
}
